import React, { useState, useEffect } from 'react';
import Navbar from './Components/Layout/Navbar';
import MobileNav from './Components/Layout/MobileNav';
import Hero from './Components/Sections/Hero';
import Stats from './Components/Sections/Stats';
import Services from './Components/Sections/Services';
import Projects from './Components/Sections/Projects';
import About from './Components/Sections/About';
import Certifications from './Components/Sections/Certifications';
import Experience from './Components/Sections/Experience';
import Footer from './Components/Layout/Footer';
import Background from './Components/UI/Background';
import { ThemeProvider } from './context/ThemeContext';

/**
 * Main Application Component
 * 
 * Orchestrates the overall layout and navigation of the portfolio website.
 * Manages the active section state and scroll behavior.
 * Wraps the entire application in the ThemeProvider for light/dark mode support.
 */
function App() {
  const [activeSection, setActiveSection] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handles rendering the appropriate component based on the active section
  const renderSection = () => {
    switch (activeSection) {
      case 'home':
        return (
          <>
            <Hero setActiveSection={setActiveSection} />
            <Stats />
            <Services />
          </>
        );
      case 'experience':
        return <div className="pt-20"><Experience /></div>;
      case 'projects':
        return <Projects />;
      case 'services':
        return <div className="pt-20"><Services /></div>;
      case 'about':
        return <div className="pt-20"><About /></div>;
      case 'certifications':
        return <div className="pt-20"><Certifications /></div>;
      default:
        return <Hero setActiveSection={setActiveSection} />;
    }
  };

  return (
    <ThemeProvider>
      <div className="min-h-screen text-slate-900 dark:text-gray-200 font-sans selection:bg-purple-500/30 relative overflow-x-hidden bg-slate-50 dark:bg-slate-900 transition-colors duration-300">
        <Background />

        <Navbar
          activeSection={activeSection}
          setActiveSection={setActiveSection}
          scrolled={scrolled}
        />

        <main className="pb-20 md:pb-0 flex flex-col min-h-screen">
          <div className="flex-grow animate-in fade-in duration-500">
            {renderSection()}
          </div>
          <Footer />
        </main>

        <MobileNav
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />
      </div>
    </ThemeProvider>
  );
}

export default App;